import Splide from "@splidejs/splide";

export default () => {
  const $carousels = document.querySelectorAll<HTMLElement>(".js-carousel");

  $carousels.forEach(($el) => {
    const splide = new Splide($el);

    // Remove the role attribute from the carousel element
    $el.removeAttribute("role");

    // Ensure that slides use an appropriate ARIA role
    splide.on("mounted", () => {
      const slides = $el.querySelectorAll(".splide__slide");
      const slideList = $el.querySelector(".splide__list");

      slides.forEach((slide) => {
        slide.removeAttribute("role");
        slide.setAttribute("role", "listitem");
      });

      if (slideList) {
        slideList.removeAttribute("role");
        slideList.setAttribute("role", "list");
      }
    });

    splide.mount();
  });
};
